import { render, staticRenderFns } from "./GamePlayerBadgePurchased.vue?vue&type=template&id=1539b386&scoped=true&"
import script from "./GamePlayerBadgePurchased.vue?vue&type=script&lang=js&"
export * from "./GamePlayerBadgePurchased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1539b386",
  null
  
)

export default component.exports